import isEqual from 'react-fast-compare';

export const deepClone = <T>(object: T): T => (
  (object === undefined ? undefined : JSON.parse(JSON.stringify(object))) as T
);

export const areFieldsEqual = <T>(obj1: T, obj2: T, fields: (keyof T)[]) => {
  if (obj1 === undefined && obj2 === undefined) return undefined;

  const dataObj1 = !obj1 ? {} : fields.reduce((acc, field) => {
    const newAcc = { ...acc };
    newAcc[field] = obj1[field];
    return newAcc;
  }, {} as Partial<T>);

  const dataObj2 = !obj2 ? {} : fields.reduce((acc, field) => {
    const newAcc = { ...acc };
    newAcc[field] = obj2[field];
    return newAcc;
  }, {} as Partial<T>);

  return isEqual(dataObj1, dataObj2);
};
